import { createAsyncThunk } from '@reduxjs/toolkit'
import Container from 'typedi'
import i18n from 'i18n'

import { RestApiService } from '@/services'
import { ApplicationState } from '@/state/root.models'
import {
  setDialogAction,
  setLoadingFullAction,
  setSnackbarAction,
} from '@/state/ui/global/slices/index.slices'

import { removeEmptyProp } from '@/utils'
import ActionTypes from '../constants'
import { CreateUserPayload, UserResponse } from '../models'

import { USER } from './api.routes'
import { getAllUsersThunk } from './get-all.thunk'

const apiService: RestApiService = Container.get(RestApiService)

const createUserThunk = createAsyncThunk(
  ActionTypes.CREATE_USER,
  async (payload: CreateUserPayload, thunkAPI) => {
    try {
      apiService.requestParams = {
        method: 'POST',
        endpoint: USER.CREATE,
        body: payload,
      }

      const { auth, user } = thunkAPI.getState() as ApplicationState

      thunkAPI.dispatch(setLoadingFullAction(true))

      const response: UserResponse = await apiService.sendAuthData(
        auth.token || '',
      )

      thunkAPI.dispatch(setLoadingFullAction(false))

      let message = i18n.t('messages.successfully', {
        item: `${i18n.t('user')} ${payload.username}`,
        what: i18n.t('created'),
      })

      if (response.username) {
        thunkAPI.dispatch(setDialogAction({ open: false }))

        thunkAPI.dispatch(getAllUsersThunk(removeEmptyProp(user.filters)))
      } else {
        message =
          typeof response.message === 'string'
            ? response.message
            : i18n.t('messages.errorOccurred')
      }

      thunkAPI.dispatch(
        setSnackbarAction({
          message,
          open: true,
          variant: response?.username ? 'success' : 'error',
        }),
      )

      return response
    } catch (error) {
      thunkAPI.dispatch(setLoadingFullAction(false))
      return thunkAPI.rejectWithValue({
        message: error,
        status: error,
      })
    }
  },
)

export default createUserThunk
